export default {
    medication: 'medication',
    medicationTitle: 'medication Title',
    medicationStatus: 'Status',
    medications: 'medications',
    editMedication: 'Edit medication',
    addMedication: 'Add medication',
}